import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },
    name: {
        show: true,
        title: i18n.t('message.name'),
        sortable: true,
        column: 'name'
    },
    is_report: {
        show: true,
        title: i18n.t('message.is_report'),
        sortable: true,
        column: 'is_report'
    },
    is_conclusion: {
        show: true,
        title: i18n.t('message.is_conclusion'),
        sortable: true,
        column: 'is_conclusion'
    },

    is_register: {
        show: true,
        title: i18n.t('message.is_register'),
        sortable: true,
        column: 'is_register'
    },


    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
